<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>

    <div class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ objEdicao.cdregiao }}</div>
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Nome</label>
                    <input type="text" v-model="objEdicao.nmregiao" required maxlength="100" v-uppercase />
                </div>

                <div class="form-item-coordenadas">
                    <CoordenadasSelect v-model:modelValueLatitude="edLatitude" v-model:modelValueLongitude="edLongitude" />
                </div>
            </div>


            <div class="row-end">
                <label for="ckAtivo">Ativo</label>
                <input id="ckAtivo" type="checkbox" class="input-checkbox" v-model="ckAtivo" />
            </div>


            <div class="row-end margin-top10">
                <button class="btn-confirm" type="submit">Salvar</button>
                <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
            </div>
        </form>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { criarRegiao } from '@/models/Regiao';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import CoordenadasSelect from '@/components/CoordenadasSelect.vue';

const emit = defineEmits(['close', 'salvo']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const ckAtivo = ref(false);
const edLatitude = ref(0);
const edLongitude = ref(0);
const objEdicao = ref(criarRegiao());
const isLoading = ref(false);

const submitForm = async () => {
    try {
        isLoading.value     = true;
        objEdicao.value.ativo     = ckAtivo.value ? 'S' : 'N';
        objEdicao.value.latitude  = !edLatitude.value ? 0 : parseFloat(edLatitude.value.toString().replace(',', '.')) || 0;
        objEdicao.value.longitude = !edLongitude.value ? 0 : parseFloat(edLongitude.value.toString().replace(',', '.')) || 0;
        const response      = await genericPut('/cad/regiao', objEdicao.value);
        if (response.bolok === 1){
            emit('salvo');
            emit('close');
        }else{
            alert(response.erro);
        }
    } catch (error) {console.error('Error:', error);
    } finally{isLoading.value=false;}
};

const cancelForm = () => {emit('close');};

const lerDados = async() => {
    try{
        isLoading.value=true;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('regiao', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){console.error('Erro leitura dos dados', error);}
        }else{
            objEdicao.value.idmunicipio = globalStore.idmunicipio;
        }
        objEdicao.value.idusuario = globalStore.idusuario;
        ckAtivo.value       = objEdicao.value.ativo === 'S';
        edLatitude.value    = objEdicao.value.latitude;
        edLongitude.value   = objEdicao.value.longitude;
    }finally{isLoading.value=false;}
};

onMounted(lerDados);
</script>